{
    "product_information__id__product_id": "Réf. art. {{value}}",
    "product_information__id__purchase_order_number": "Réf. fourn. {{value}}",
    "product_information__id__ean": "EAN {{value}}",
    "product_information__id__gtin": "GTIN {{value}}",
    "description": "Description",
    "recommendations": "Articles associés",
    "recommendations__tooltip": "Articles complémentaires souvent choisis ensemble.",
    "variants": "Variantes",
    "info_block_title__product_group": "Groupe de produits",
    "info_block_title__supplier": "Fournisseur",
    "info_block_title__total_availability": "Disponibilité totale",
    "info_block_title__packaging": "Conditionnement",
    "tab_title__info": "Infos article",
    "tab_title__availability": "Disponibilité",
    "tab_title__quotes": "Devis",
    "tab_title__orders": "Commandes",
    "tab_title__explorer": "Analyse des ventes",
    "quick_add": "Ajouter",
    "table_header__total_tooltip": "Peut différer du prix unitaire × quantité en raison de remises au niveau des lignes.",
    "table_header__item_id": "N° article",
    "table_header__item_name": "Article",
    "search_placeholder": "Rechercher un article"
}
